export enum MOI {
  SYSTEM = 10,
  FORM_EDITOR = 12,
  POSKEYLAYOUT_EDITOR = 13,
  MESSAGE_IN_LANGUAGE = 14,
  GL_EDITOR = 16,
  SCHEDULE_MANAGER = 17,
  SCHEDULE_FORM = 18,
  REPORT_MODULE = 19,
  CASH_MANAGER = 20,
  VENUE_EDITOR = 22,
  ALLOCATION_WIZARD = 23,
  PARAMETER_EDITOR = 24,
  SV_EDITOR = 25,
  OFFLINE_MANAGER = 26,
  FILM_HIRE_POLICY = 27,
  FILM_HIRE_EVENT_MASTER = 28,
  FILM_HIRE_ASSIGMENT = 29,
  CASHIER = 31,
  SEAT_SWAP = 33,
  MENUTREE_EDITOR = 35,
  GL_EXPORT = 36,
  LIVE_MONITOR = 37,
  END_OF_DAY = 38,
  PRICING = 39,
  RESERVATION_QUERY = 43,
  TICKET_LAYOUT = 44,
  FILM_HIRE_TICKET_SALE_EXPORT = 45,
  FILM_HIRE_DISTRIBUTOR_EXPORT = 40002,
  MEMBERSHIP_EDITOR = 47,
  TICKET_GROUP_DEFAULT = 48,
  MEDIA_UPLOADER = 49,
  TRAILER_MANAGER = 51,
  EVENT_STATUS = 53,
  CANCEL_PAYMENTS = 54,
  RETAIL_PROMOTION = 55,
  SUBSCRIPTION_MANAGEMENT = 61,
  SUBSCRIPTION_RULE = 62,
  TICKET_RULE = 63,
  PRODUCT_WIZARD = 65,
  CREDIT_REPORT = 67,
  SUNSET_MODULE = 68,
  PAYMENT_TOKEN = 69,
  CUSTOMER_CAMPAIGNS = 71,
  ITEM_IN_SITE = 73,
  INVENTORY_ADJUSTMENT = 7600,
  INVENTORY_INFO = 7702,
  INVENTORY_COUNT = 8000,
  INVENTORY_COUNTER = 301,
  POS_MESSAGE = 18000,
  SPECIAL_EVENT = 25520,
  SYSTEM_VALIDATION = 26500,
  COUNTIT = 26520,
  EMAIL_EDITOR = 26550,
  PROMOTION_PROVIDER_EDITOR = 22880,
  PRODUCT_INGREDIENT_DETAILS = 19010,
  EXTERNAL_EXPORT = 50000,
  EXCEL_EXPORT = 50100,
  SCHEDULED_NOTIFICATION = 15850,
  DASHBOARD_MONITOR = 97,
  BPANALYTICS = 98,
  DYNAMIC_DASHBOARD = 90000,
  FILE_MANAGER = 85,
  SCREEN_SYSTEM = 86,
  EVENTS_EDITOR = 87,
  IRS_IL_EXPORT = 190,
}
